import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from 'shared/api/baseQuery';

import { ErrorReportRequestDto } from './dto/error-report.request.dto';
import {
  QuestionRequestDto,
  QuestionResponseDto,
  QuestionVoiceRequestDto,
} from './dto/question-request.dto';

export const agentApi = createApi({
  reducerPath: 'agent-api',
  baseQuery,
  endpoints: builder => {
    return {
      ask: builder.mutation<QuestionResponseDto, QuestionRequestDto>({
        query: data => {
          return {
            method: 'POST',
            url: 'api/ai-agent/query',
            body: data,
            timeout: 45000,
          };
        },
      }),
      voice: builder.mutation<QuestionResponseDto, QuestionVoiceRequestDto>({
        query: data => {
          const formData = new FormData();
          formData.append('file', data.file);
          return {
            method: 'POST',
            url: 'api/ai-agent/voice-transcibe',
            body: formData,
          };
        },
      }),
      reportError: builder.mutation<void, ErrorReportRequestDto>({
        query: data => {
          return {
            method: 'POST',
            url: '/api/ai-agent/error-report',
            body: data,
          };
        },
      }),
    };
  },
});

export const { useAskMutation, useVoiceMutation, useReportErrorMutation } =
  agentApi;
